export const parseTemplateTokenPanelData = (data: unknown): string => {
    if (typeof data === 'string') {
        return data;
    }

    if (typeof data === 'object' && data !== null) {
        const { templateToken } = data as { templateToken?: unknown };

        return typeof templateToken === 'string' ? templateToken : '';
    }

    return '';
};
